module.exports = __webpack_public_path__ + "img/add-new-import-light.6c548f6d.svg";